import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze persoon de toegang wilt ontzeggen?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Deze persoon kan daarna niet meer werken op een bouwplaats van Thunnissen en collega uitvoerders krijgen een melding wanneer ze deze persoon willen registreren.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Naam", -1)
const _hoisted_4 = { class: "no-mb" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Geboortedatum", -1)
const _hoisted_6 = { class: "no-mb" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Reden van weigeren", -1)

import { ref, withDefaults } from 'vue'
import { StopOutlined, CheckOutlined } from '@ant-design/icons-vue'
import axios from 'axios/index'
import { notification } from 'ant-design-vue'

interface Props {
  icon?: boolean
  showUndo?: boolean
  size?: 'small' | 'default' | 'large'
  constructionWorker: { id:number, firstname:string, lastname:string, date_of_birth:string, denied: { is_denied:boolean } }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DenyConstructionWorker',
  props: {
    icon: { type: Boolean, default: false },
    showUndo: { type: Boolean, default: false },
    size: { default: 'default' },
    constructionWorker: null
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props as { icon: boolean, showUndo: boolean, size: 'small' | 'default' | 'large', constructionWorker: { id:number, firstname:string, lastname:string, date_of_birth:string, denied: { is_denied:boolean } } };




const saving = ref(false)
const showDenyAccessModal = ref(false)
const denyAccess = ref<{ constructionWorkerId:number|null, name: string|null, date_of_birth: string|null, reason: string|null }>({
  constructionWorkerId: null,
  name: null,
  date_of_birth: null,
  reason: null
})

function toggleDenyAccessModal () : void {
  showDenyAccessModal.value = !showDenyAccessModal.value

  if (showDenyAccessModal.value) {
    denyAccess.value = {
      constructionWorkerId: props.constructionWorker.id,
      name: props.constructionWorker.firstname + ' ' + props.constructionWorker.lastname,
      date_of_birth: new Date(props.constructionWorker.date_of_birth).toLocaleDateString('nl-NL'),
      reason: null
    }
  } else {
    denyAccess.value = { constructionWorkerId: null, name: null, date_of_birth: null, reason: null }
  }
}

function enableAccess () : void {
  saving.value = true
  axios.post(process.env.VUE_APP_API_URL + '/constructionWorkers/' + props.constructionWorker.id + '/allow').then(() => {
    emit('update', true)
    notification.success({
      message: 'Toegang succesvol gegeven.',
      description: 'De bouwplaatsmedewerker kan weer geregistreerd worden op een van onze bouwplaatsen.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens geven van toegang aan bouwplaatsmedewerker!',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.'
    })
  }).finally(() => {
    saving.value = false
  })
}

function denyConstructionWorker () : void {
  saving.value = true
  axios.post(process.env.VUE_APP_API_URL + '/constructionWorkers/' + denyAccess.value.constructionWorkerId + '/deny', { reason: denyAccess.value.reason }).then(() => {
    emit('update', true)
    toggleDenyAccessModal()
    notification.success({
      message: 'Toegang succesvol ontzegd.',
      description: 'De bouwplaatsmedewerker kan niet langer geregistreerd worden op een van onze bouwplaatsen.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens weigeren van bouwplaatsmedewerker!',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.'
    })
  }).finally(() => {
    saving.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.constructionWorker.denied.is_denied || !props.showUndo)
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          type: "danger",
          size: props.size,
          onClick: toggleDenyAccessModal,
          disabled: saving.value || __props.constructionWorker.denied.is_denied
        }, _createSlots({
          default: _withCtx(() => [
            (!props.icon)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Weigeren")
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (props.icon)
            ? {
                name: "icon",
                fn: _withCtx(() => [
                  _createVNode(_unref(StopOutlined))
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["size", "disabled"]))
      : (props.showUndo)
        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
            key: 1,
            title: "Deze persoon weer toegang geven?",
            "ok-text": "Ja, toegang geven",
            "cancel-text": "Annuleren",
            onConfirm: enableAccess,
            disabled: saving.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                size: props.size,
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, _createSlots({
                default: _withCtx(() => [
                  (!props.icon)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Toegang geven")
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, [
                (props.icon)
                  ? {
                      name: "icon",
                      fn: _withCtx(() => [
                        _createVNode(_unref(CheckOutlined))
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["size"])
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      title: "Toegang tot bouwplaats ontzeggen.",
      "ok-text": "Ja, toegang ontzeggen",
      "ok-button-props": { disabled: !denyAccess.value.reason || saving.value, loading: saving.value },
      visible: showDenyAccessModal.value,
      onCancel: toggleDenyAccessModal,
      onOk: denyConstructionWorker
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: [16,16],
          class: "no-mb"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("p", _hoisted_4, _toDisplayString(denyAccess.value.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createElementVNode("p", _hoisted_6, _toDisplayString(denyAccess.value.date_of_birth), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_component_a_textarea, {
                  value: denyAccess.value.reason,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((denyAccess.value.reason) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["ok-button-props", "visible"])
  ], 64))
}
}

})